import API from "../API/newIndex";

export const uploadTextEditorImage = async (file) => {
  console.log(file, 'file');
  const result = await API({
    url: "/admin/fileupload/upload",
    method: "POST",
    data: file,
  });
console.log(result, 'result');
  if (result?.data?.data?.length > 0) {
    return result.data.data[0];
  }

  throw new Error("Image upload failed");
};

export const isAscendingOrder = (order) => {
  if (!order) return false;
  if (typeof order === 'string') {
    const upper = order.trim().toUpperCase();
    return upper === 'ASC' || upper === 'A-Z' || upper === '1' || upper === 'TRUE';
  }
  if (typeof order === 'object') {
    if (order.orderByValue !== undefined) {
      const upper = String(order.orderByValue).trim().toUpperCase();
      return upper === 'ASC' || upper === 'A-Z' || upper === '1' || upper === 'TRUE';
    }
    if (order.order_by !== undefined) {
      const upper = String(order.order_by).trim().toUpperCase();
      return upper === 'ASC' || upper === 'A-Z' || upper === '1' || upper === 'TRUE';
    }
    if (order.order !== undefined) {
      const upper = String(order.order).trim().toUpperCase();
      return upper === 'ASC' || upper === 'A-Z' || upper === '1' || upper === 'TRUE';
    }
    if (order.direction !== undefined) {
      const upper = String(order.direction).trim().toUpperCase();
      return upper === 'ASC' || upper === 'A-Z' || upper === '1' || upper === 'TRUE';
    }
  }
  return false;
};
